import { Button, Heading, Section, Wrapper } from 'components/base';
import Columns from 'components/Columns';
import CardItem from 'components/TestimonialCard';
import PropTypes from 'prop-types';
import React from 'react';

const Customers = ({ data: { heading, list } }) => {
  const filteredList = list.filter(item => item.pick3 === 'true');
  return (
    <Section padding="Xl">
      <Wrapper>
        <Heading Tag="h2" size="L" marginBottom="M" bold center>
          {heading}
        </Heading>
        <Columns
          Item={CardItem}
          items={filteredList}
          columnCount={3}
          rowGap="S"
        />
        <Section center padding="TopM">
          <Button type="ghostTertiary" text="更多用戶" to="/customers/" />
        </Section>
      </Wrapper>
    </Section>
  );
};

Customers.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Customers;
